var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSpinner = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.997 21.5a9.2 9.2 0 0 1-3.683-.747 9.6 9.6 0 0 1-3.026-2.041 9.6 9.6 0 0 1-2.04-3.026 9.2 9.2 0 0 1-.748-3.683q0-1.975.749-3.7a9.7 9.7 0 0 1 2.04-3.015A9.6 9.6 0 0 1 8.314 3.25 9.2 9.2 0 0 1 12 2.5q.319 0 .534.216a.73.73 0 0 1 .216.534.73.73 0 0 1-.216.535A.73.73 0 0 1 12 4Q8.675 4 6.337 6.337 4.001 8.675 4 12c-.001 3.325.78 4.104 2.337 5.663Q8.675 19.999 12 20c3.325.001 4.104-.78 5.663-2.337Q19.999 15.325 20 12q0-.32.216-.535a.73.73 0 0 1 .534-.215q.32 0 .535.216A.73.73 0 0 1 21.5 12q0 1.95-.75 3.685a9.6 9.6 0 0 1-2.038 3.027 9.7 9.7 0 0 1-3.016 2.039q-1.725.75-3.7.749Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSpinner);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/spinner.944f48e1.svg";